import script from "./desktopReadcode.vue?vue&type=script&setup=true&lang=js"
export * from "./desktopReadcode.vue?vue&type=script&setup=true&lang=js"

import "./desktopReadcode.vue?vue&type=style&index=0&id=08243a8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08243a8f"]])

export default __exports__